import { baseUseNotifyStore } from "../packages/datakode/nuxt-datakode-utils/store/notify"
import { baseUseConfigStore } from "../packages/datakode/nuxt-datakode-utils/store/config"
import { baseUseUserStore } from "../packages/datakode/nuxt-datakode-utils/store/user"
import { baseUseOnlineStore, getter, setter, unsetter } from "./online"
import { baseUseEpciCommuneStore } from "./epciCommuneStore"

export const useNotifyStore = baseUseNotifyStore
export const useConfigStore = baseUseConfigStore
export const useUserStore = baseUseUserStore
export const useOnlineStore = baseUseOnlineStore
export const useEpciCommuneStore = baseUseEpciCommuneStore
export const get = getter
export const set = setter
export const unset = unsetter
